/* Brand search box for long filter lists (7 Oct 2026). Collection v2 + search v2, desktop panel and
   phone drawer. facets.js swaps filter HTML on every change, so a MutationObserver re-adds the box. */
(function () {
  var MIN = 12;
  var label = (document.currentScript && document.currentScript.dataset.label) || 'Search';
  // Brand label only: the product count sits in the same item, and digits would otherwise match it
  function brandName(li) {
    var label = li.querySelector('.facet-checkbox__label') || li;
    var text = label.textContent;
    var count = label.querySelector('.facet-checkbox__label-count');
    if (count) text = text.replace(count.textContent, '');
    return text.trim().toLowerCase();
  }
  function enhance(root) {
    (root || document).querySelectorAll('input[name="filter.p.vendor"]').forEach(function (input) {
      var list = input.closest('ul');
      if (!list || list.dataset.ycBrandSearch) return;
      var items = list.querySelectorAll(':scope > li');
      if (items.length < MIN) return;
      list.dataset.ycBrandSearch = '1';
      var box = document.createElement('input');
      box.type = 'search';
      box.className = 'yc-brand-search';
      box.placeholder = label;
      box.setAttribute('aria-label', label);
      box.autocomplete = 'off';
      // keep typing out of the facets form (its input/change events would trigger a filter refresh)
      box.removeAttribute('name');
      ['input', 'change', 'keydown'].forEach(function (t) {
        box.addEventListener(t, function (e) {
          e.stopPropagation();
          if (t === 'keydown' && e.key === 'Enter') e.preventDefault();
          if (t === 'keydown') return;
          var q = box.value.trim().toLowerCase();
          items.forEach(function (li) {
            li.style.display = q !== '' && brandName(li).indexOf(q) === -1 ? 'none' : '';
          });
        });
      });
      list.parentNode.insertBefore(box, list);
    });
  }
  function run() {
    enhance(document);
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { enhance(document); }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
